import {
  dateWithComma,
  dateWithSlashes,
  formatNoTimeDate,
} from "@/utilities/date";

export enum DateStringFormat {
  COMMA = "comma",
  SLASHES = "slashes",
}

interface IDateStringProps {
  date: string;
  format: DateStringFormat;
  hasTime?: boolean;
}

const DateString = (props: IDateStringProps) => {
  const { date, format, hasTime = true } = props;

  switch (format) {
    case DateStringFormat.COMMA:
      return dateWithComma(date);
    case DateStringFormat.SLASHES:
      if (hasTime) {
        return dateWithSlashes(date);
      } else {
        return formatNoTimeDate(date);
      }
  }
};

export default DateString;
